/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Settings_Success_Setdefaultcategory2Inputs */

const en_cases_settings_success_setdefaultcategory2 = /** @type {(inputs: Cases_Settings_Success_Setdefaultcategory2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default category updated`)
};

/**
* | output |
* | --- |
* | "Default category updated" |
*
* @param {Cases_Settings_Success_Setdefaultcategory2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cases_settings_success_setdefaultcategory2 = /** @type {((inputs?: Cases_Settings_Success_Setdefaultcategory2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Settings_Success_Setdefaultcategory2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cases_settings_success_setdefaultcategory2(inputs)
});
export { cases_settings_success_setdefaultcategory2 as "cases_settings_success_setDefaultCategory" }